import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { hasPermission } from "@/constants/permissions";

function homeRouteFor(user) {
  return user.role === "superadmin" ? "/tenants" : "/dashboard";
}

export default function ProtectedRoute({ children, permission, roles }) {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div style={{ display: "grid", placeItems: "center", minHeight: "100vh", background: "var(--bg)", color: "var(--fg)" }} data-testid="auth-loading">
        Loading...
      </div>
    );
  }

  if (user === false) {
    return <Navigate to="/login" replace />;
  }

  if (roles && !roles.includes(user.role)) {
    return <Navigate to={homeRouteFor(user)} replace />;
  }

  if (permission && !hasPermission(user, permission)) {
    return <Navigate to={homeRouteFor(user)} replace />;
  }

  return children;
}
